

















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
  components: {}
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.FinanceManageServiceProxy();
  }
  input: proxy.MerchantTotalUpfrontStatisticsPageInputDto =
    new proxy.MerchantTotalUpfrontStatisticsPageInputDto();
  sub_id = 0;
  createOrEditShow = false;
  createrange = [];
  merchants = [];
  totalOrderNum = 0;
  totalAmount = 0;
  commission = 0;
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },

    {
      title: '类型',
      key: 'type',
    },
    {
      title: '总余额',
      key: 'allBalance',
    },
    {
      title: '总预付',
      key: 'allAdvance',
    },
    {
      title: '实时余额',
      key: 'realBalance'
    },
    {
      title: '创建时间',
      slot: 'createTime'
    }
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.startTime = this.createrange[0];
    this.input.endTime = this.createrange[1];
    this.prox.queryMerchantTotalUpfrontStatistics(this.input).then(x => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  // exportrecord() {
  //   var ids = this.selectedDataItems.map((x) => {
  //     return x.id;
  //   });
  //   this.input.ids = ids;
  //   this.prox.exportMerchant(this.input).then((x) => {
  //     location.href =
  //       AppConsts.remoteServiceBaseUrl +
  //       '/File/DownloadTempFile?FileToken=' +
  //       x.fileToken +
  //       '&fileName=' +
  //       x.fileName +
  //       '&fileType=' +
  //       x.fileType;
  //   });
  // }
  getpage() {
    this.OnInit();
  }
  async created() {
    let mreq = new proxy.MerchantSimpleInputDto();
    new proxy.MerchantServiceProxy().queryAllList(mreq).then((x) => {
      this.merchants = x;
    });
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    this.getpage();
  }

}
